// enum.ts
var genderType = {
  1: "\u5973",
  2: "\u7537",
  3: "\u5176\u4ED6"
};
var statusType = {
  normal: { text: "\u6B63\u5E38", status: "Success" },
  disable: { text: "\u7981\u7528", status: "Error" },
  check: { text: "\u5BA1\u6838", status: "Processing" },
  reject: { text: "\u62D2\u7EDD", status: "Warning" },
  ignore: { text: "\u5FFD\u7565", status: "Warning" },
  delete: { text: "\u5220\u9664", status: "Default" }
};
var feedType = /* @__PURE__ */ ((feedType2) => {
  feedType2["FOLLOW"] = "follow";
  feedType2["SCORE"] = "score";
  feedType2["EVALUATE"] = "evaluate";
  feedType2["ADD"] = "add";
  feedType2["UPDATE"] = "update";
  feedType2["DONE"] = "done";
  feedType2["WISH"] = "wish";
  feedType2["DOING"] = "doing";
  feedType2["ON_HOLD"] = "on_hold";
  feedType2["DROPPEND"] = "dropped";
  feedType2["UP"] = "up";
  feedType2["INTEREST"] = "interest";
  feedType2["COMMENT"] = "comment";
  feedType2["FORWARD"] = "forward";
  feedType2["FEED"] = "feed";
  feedType2["BOOKMARK"] = "bookmark";
  feedType2["ADD_FRIEND"] = "add_friend";
  feedType2["REPLY"] = "reply";
  feedType2["SHARE"] = "share";
  feedType2["DOWN"] = "down";
  feedType2["SEASON"] = "season";
  feedType2["DELETE"] = "delete";
  feedType2["COLLECTION"] = "collection";
  return feedType2;
})(feedType || {});
var modelName = /* @__PURE__ */ ((modelName2) => {
  modelName2[modelName2["SUBJECT"] = 1] = "SUBJECT";
  modelName2[modelName2["NEWS"] = 2] = "NEWS";
  modelName2[modelName2["PERSON"] = 3] = "PERSON";
  modelName2[modelName2["SUBJECT_FIELDS"] = 4] = "SUBJECT_FIELDS";
  modelName2[modelName2["EPISODE"] = 5] = "EPISODE";
  modelName2[modelName2["CHARACTER"] = 6] = "CHARACTER";
  modelName2[modelName2["SUBJECT_INTEREST"] = 7] = "SUBJECT_INTEREST";
  modelName2[modelName2["TAG"] = 8] = "TAG";
  modelName2[modelName2["PIN"] = 9] = "PIN";
  modelName2[modelName2["FORWARD"] = 10] = "FORWARD";
  modelName2[modelName2["COMMENT"] = 11] = "COMMENT";
  modelName2[modelName2["REPLY"] = 12] = "REPLY";
  modelName2[modelName2["FEED"] = 13] = "FEED";
  modelName2[modelName2["TOPIC"] = 14] = "TOPIC";
  modelName2[modelName2["LISTS"] = 15] = "LISTS";
  modelName2[modelName2["ACOTR"] = 16] = "ACOTR";
  modelName2[modelName2["USER"] = 17] = "USER";
  modelName2[modelName2["BOOKMARK"] = 18] = "BOOKMARK";
  modelName2[modelName2["CHANGES"] = 19] = "CHANGES";
  modelName2[modelName2["ATTACHMENT"] = 20] = "ATTACHMENT";
  modelName2[modelName2["HOME"] = 21] = "HOME";
  modelName2[modelName2["LIST"] = 22] = "LIST";
  modelName2[modelName2["PERSON_CHARACTERS"] = 23] = "PERSON_CHARACTERS";
  modelName2[modelName2["SUBJECT_CHARACTERS"] = 24] = "SUBJECT_CHARACTERS";
  modelName2[modelName2["SUBJECT_PERSONS"] = 25] = "SUBJECT_PERSONS";
  modelName2[modelName2["ACTIVITY"] = 26] = "ACTIVITY";
  modelName2[modelName2["COLLECTION"] = 27] = "COLLECTION";
  modelName2[modelName2["POST"] = 28] = "POST";
  return modelName2;
})(modelName || {});
var ActivityAction = /* @__PURE__ */ ((ActivityAction2) => {
  ActivityAction2["RATE"] = "rate";
  ActivityAction2["COMMENT"] = "comment";
  ActivityAction2["REPLY"] = "reply";
  ActivityAction2["WISH"] = "wish";
  ActivityAction2["DONE"] = "done";
  ActivityAction2["DOING"] = "doing";
  ActivityAction2["ON_HOLD"] = "on_hold";
  ActivityAction2["DROPPED"] = "dropped";
  ActivityAction2["BOOKMARK"] = "bookmark";
  ActivityAction2["DIGG"] = "digg";
  ActivityAction2["FOLLOW"] = "follow";
  ActivityAction2["SHARE"] = "share";
  ActivityAction2["CREATE"] = "create";
  ActivityAction2["UPDATE"] = "update";
  ActivityAction2["DELETE"] = "delete";
  ActivityAction2["COLLECTION"] = "collection";
  ActivityAction2["POST"] = "post";
  return ActivityAction2;
})(ActivityAction || {});
var ActivityActionName = {
  ["rate" /* RATE */]: "\u8BC4\u5206",
  ["comment" /* COMMENT */]: "\u8BC4\u8BBA",
  ["reply" /* REPLY */]: "\u56DE\u590D",
  ["wish" /* WISH */]: "\u60F3\u770B",
  ["done" /* DONE */]: "\u770B\u8FC7",
  ["doing" /* DOING */]: "\u5728\u770B",
  ["on_hold" /* ON_HOLD */]: "\u6401\u7F6E",
  ["dropped" /* DROPPED */]: "\u629B\u5F03",
  ["bookmark" /* BOOKMARK */]: "\u6536\u85CF",
  ["digg" /* DIGG */]: "\u70B9\u8D5E",
  ["follow" /* FOLLOW */]: "\u5173\u6CE8",
  ["share" /* SHARE */]: "\u5206\u4EAB",
  ["create" /* CREATE */]: "\u521B\u5EFA",
  ["update" /* UPDATE */]: "\u66F4\u65B0",
  ["delete" /* DELETE */]: "\u5220\u9664",
  ["collection" /* COLLECTION */]: "\u5408\u96C6",
  ["post" /* POST */]: "\u53D1\u5E03"
};
var sidName = {
  [1 /* SUBJECT */]: "subject",
  [2 /* NEWS */]: "news",
  [3 /* PERSON */]: "person",
  [4 /* SUBJECT_FIELDS */]: "fields",
  [5 /* EPISODE */]: "episode",
  [6 /* CHARACTER */]: "character",
  [7 /* SUBJECT_INTEREST */]: "subject_interest",
  [8 /* TAG */]: "tag",
  [9 /* PIN */]: "pin",
  [10 /* FORWARD */]: "forward",
  [11 /* COMMENT */]: "comment",
  [12 /* REPLY */]: "reply",
  [13 /* FEED */]: "feed",
  [14 /* TOPIC */]: "topic",
  [15 /* LISTS */]: "lists",
  [16 /* ACOTR */]: "actors",
  [18 /* BOOKMARK */]: "bookmark",
  [17 /* USER */]: "user",
  [19 /* CHANGES */]: "changes",
  [20 /* ATTACHMENT */]: "attachment",
  [21 /* HOME */]: "home",
  [22 /* LIST */]: "list",
  [23 /* PERSON_CHARACTERS */]: "person_characters",
  [24 /* SUBJECT_CHARACTERS */]: "subject_characters",
  [25 /* SUBJECT_PERSONS */]: "subject_persons",
  [26 /* ACTIVITY */]: "activity",
  [27 /* COLLECTION */]: "collection",
  [28 /* POST */]: "post"
};
var modelEnName = {
  [1 /* SUBJECT */]: "Subject",
  [2 /* NEWS */]: "News",
  [3 /* PERSON */]: "Person",
  [4 /* SUBJECT_FIELDS */]: "SubjectFields",
  [5 /* EPISODE */]: "Episode",
  [6 /* CHARACTER */]: "Character",
  [7 /* SUBJECT_INTEREST */]: "SubjectInterest",
  [8 /* TAG */]: "Tag",
  [9 /* PIN */]: "Pins",
  [10 /* FORWARD */]: "Forward",
  [11 /* COMMENT */]: "Comments",
  [12 /* REPLY */]: "Reply",
  [13 /* FEED */]: "Feed",
  [14 /* TOPIC */]: "Topic",
  [15 /* LISTS */]: "Detailedlist",
  [16 /* ACOTR */]: "Actor",
  [17 /* USER */]: "User",
  [18 /* BOOKMARK */]: "Bookmark",
  [19 /* CHANGES */]: "Changes",
  [20 /* ATTACHMENT */]: "Attachment",
  [21 /* HOME */]: "Home",
  [22 /* LIST */]: "List",
  [23 /* PERSON_CHARACTERS */]: "PersonCharacters",
  [24 /* SUBJECT_CHARACTERS */]: "SubjectCharacters",
  [25 /* SUBJECT_PERSONS */]: "SubjectPersons",
  [27 /* COLLECTION */]: "Collection",
  [28 /* POST */]: "Post"
};
var modelType = {
  [1 /* SUBJECT */]: "\u5267\u96C6",
  [2 /* NEWS */]: "\u65B0\u95FB",
  [3 /* PERSON */]: "\u4EBA\u7269",
  [4 /* SUBJECT_FIELDS */]: "\u5267\u96C6\u4FE1\u606F",
  [5 /* EPISODE */]: "\u5206\u96C6",
  [6 /* CHARACTER */]: "\u89D2\u8272",
  [7 /* SUBJECT_INTEREST */]: "\u5267\u96C6\u6536\u85CF\u8BC4\u5206",
  [8 /* TAG */]: "\u6807\u7B7E",
  [9 /* PIN */]: "\u52A8\u6001",
  [10 /* FORWARD */]: "\u8F6C\u53D1",
  [11 /* COMMENT */]: "\u8BC4\u8BBA",
  [12 /* REPLY */]: "\u56DE\u590D",
  [13 /* FEED */]: "\u52A8\u6001",
  [14 /* TOPIC */]: "\u8BDD\u9898",
  [15 /* LISTS */]: "\u6E05\u5355",
  [16 /* ACOTR */]: "\u6F14\u5458",
  [17 /* USER */]: "\u7528\u6237",
  [18 /* BOOKMARK */]: "\u4E66\u7B7E",
  [19 /* CHANGES */]: "\u5386\u53F2",
  [20 /* ATTACHMENT */]: "\u9644\u4EF6",
  [21 /* HOME */]: "\u9996\u9875",
  [22 /* LIST */]: "\u5206\u7C7B",
  [23 /* PERSON_CHARACTERS */]: "\u4EBA\u7269\u89D2\u8272",
  [24 /* SUBJECT_CHARACTERS */]: "\u5267\u96C6\u89D2\u8272",
  [25 /* SUBJECT_PERSONS */]: "\u5267\u96C6\u4EBA\u7269",
  [27 /* COLLECTION */]: "\u5408\u96C6",
  [28 /* POST */]: "\u5E16\u6587"
};
var langType = {
  cn: "\u4E2D",
  en: "\u82F1"
};
var sourceSite = {
  douban: "\u8C46\u74E3",
  bangumi: "\u756A\u7EC4\u8BA1\u5212",
  tmdb: "TMDB",
  mal: "MyAnimeList",
  anilist: "AniList",
  bilibili: "\u54D4\u54E9\u54D4\u54E9",
  iqiyi: "\u7231\u5947\u827A",
  youku: "\u4F18\u9177",
  qq: "\u817E\u8BAF",
  baike: "\u767E\u79D1",
  anidb: "AniDB",
  facebook: "Facebook",
  instagram: "Instagram",
  twitter: "Twitter",
  imdb: "IMDB",
  tvdb: "TVDB",
  wikidata: "Wikidata"
};
var formatPic = "?imageMogr2/format/webp/thumbnail/64x64";
var source = {
  douban: {
    name: "\u8C46\u74E3",
    url: "https://www.douban.com/subject/",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/douban.png${formatPic}`,
    host: "https://www.douban.com"
  },
  baike: {
    name: "\u767E\u5EA6\u767E\u79D1",
    url: "https://baike.baidu.com/item/",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/baike.png${formatPic}`,
    host: "https://baike.baidu.com"
  },
  bangumi: {
    name: "\u756A\u7EC4\u8BA1\u5212",
    url: "https://bgm.tv/subject/",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/bangumi.png${formatPic}`,
    host: "https://bgm.tv"
  },
  bilibili: {
    name: "\u54D4\u54E9\u54D4\u54E9",
    url: "https://www.bilibili.com/bangumi/media/",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/bilibili.png${formatPic}`,
    host: "https://www.bilibili.com"
  },
  iqiyi: {
    name: "\u7231\u5947\u827A",
    url: "https://www.iqiyi.com/{id}.html",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/iqiyi.png${formatPic}`,
    host: "https://www.iqiyi.com"
  },
  youku: {
    name: "\u4F18\u9177",
    url: "https://v.youku.com/v_show/{id}.html",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/youku.png${formatPic}`,
    host: "https://www.youku.com"
  },
  qq: {
    name: "\u817E\u8BAF\u89C6\u9891",
    url: "https://v.qq.com/x/cover/{id}.html",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/vqq.png${formatPic}`,
    host: "https://v.qq.com"
  },
  mal: {
    name: "MyAnimeList",
    url: "https://myanimelist.net/anime/",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/myanimelist.png${formatPic}`,
    host: "https://myanimelist.net"
  },
  anidb: {
    name: "AniDB",
    url: "https://anidb.net/anime/",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/anidb.png${formatPic}`,
    host: "https://anidb.net"
  },
  tmdb: {
    name: "TMDB",
    url: "https://www.themoviedb.org/",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/tmdb.png${formatPic}`,
    host: "https://www.themoviedb.org"
  },
  facebook: {
    name: "Facebook",
    url: "https://www.facebook.com/",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/facebook.png${formatPic}`,
    host: "https://www.facebook.com"
  },
  instagram: {
    name: "Instagram",
    url: "https://www.instagram.com/",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/instagram.png${formatPic}`,
    host: "https://www.instagram.com"
  },
  twitter: {
    name: "Twitter",
    url: "https://twitter.com/",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/twitter.png${formatPic}`,
    host: "https://twitter.com"
  },
  imdb: {
    name: "IMDB",
    url: "https://www.imdb.com/title/",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/imdb.png${formatPic}`,
    host: "https://www.imdb.com"
  },
  tvdb: {
    name: "TVDB",
    url: "https://thetvdb.com/",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/tvdb.png${formatPic}`,
    host: "https://thetvdb.com"
  },
  wikidata: {
    name: "Wikidata",
    url: "https://www.wikidata.org/wiki/",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/wikidata.png${formatPic}`,
    host: "https://www.wikidata.org"
  },
  anilist: {
    name: "AniList",
    url: "https://anilist.co/anime/",
    icon: `https://cms-1251036128.cos.ap-shanghai.myqcloud.com/dakedake/static/icon/anilist.png${formatPic}`,
    host: "https://anilist.co"
  }
};
var sourceType = {
  social: "\u793E\u4EA4",
  data: "\u6570\u636E\u5E93",
  archive: "\u5B58\u6863",
  stream: "\u6D41\u5A92\u4F53",
  download: "\u4E0B\u8F7D"
};
var seasonType = {
  spring: "\u6625\u5B63",
  summer: "\u590F\u5B63",
  fall: "\u79CB\u5B63",
  winter: "\u51AC\u5B63"
};
var season = {
  spring: "\u6625\u5B63(4-6)",
  summer: "\u590F\u5B63(7-9)",
  fall: "\u79CB\u5B63(10-12)",
  winter: "\u51AC\u5B63(1-3)"
};
var picType = { posters: "\u6D77\u62A5", logos: "\u6807\u5FD7", backdrops: "\u5267\u7167", backdrop: "\u80CC\u666F\u56FE\u7247" };
var rateType = {
  wish: "\u60F3\u770B",
  done: "\u770B\u8FC7",
  doing: "\u5728\u770B",
  on_hold: "\u6401\u7F6E",
  dropped: "\u629B\u5F03"
};
var defaultTags = "\u539F\u521B,\u5192\u9669,\u70ED\u8840,\u7231\u60C5,\u641E\u7B11,\u540E\u5BAB,\u9752\u6625,\u6B4C\u821E,\u97F3\u4E50,\u65E5\u5E38,\u6821\u56ED,\u5076\u50CF,\u840C\u7CFB,\u841D\u8389,\u6C99\u96D5,\u604B\u7231,\u673A\u6218,\u5E7B\u60F3,\u79D1\u5E7B,\u5947\u5E7B,\u67B6\u7A7A,\u795E\u9B54,\u795E\u602A,\u4FEE\u771F,\u4FEE\u4ED9,\u7384\u5E7B,\u5FCD\u8005,\u672B\u65E5,\u730E\u5947,\u7A7F\u8D8A,\u7F8E\u98DF,\u7ADE\u6280,\u68D2\u7403,\u767E\u5408,\u52B1\u5FD7,\u804C\u573A,\u6CBB\u6108,\u50AC\u6CEA,\u6B66\u4FA0,\u803D\u7F8E,\u60AC\u7591,\u63A8\u7406,\u60CA\u609A,\u72AF\u7F6A,\u5267\u60C5,\u6218\u4E89,\u6218\u6597,\u71C3,\u5356\u8089,R18,\u590D\u4EC7,\u667A\u6597,\u683C\u6597,\u513F\u7AE5,\u5C11\u5973,\u53E4\u98CE,\u53E4\u88C5,\u9B54\u6CD5,\u9B54\u5973,\u5386\u53F2,\u6050\u6016,\u8FD0\u52A8,\u52A8\u4F5C,\u7AE5\u8BDD,\u771F\u4EBA,\u5F02\u4E16\u754C,\u5438\u8840\u9B3C,\u5973\u6027\u5411,\u6CE1\u9762\u756A,\u6F2B\u753B\u6539,\u5C0F\u8BF4\u6539,\u52A8\u6001\u6F2B,\u6E38\u620F\u6539,3D";
var lang = [
  { value: "zh", title: "Mandarin", label: "\u6C49\u8BED" },
  { value: "en", title: "English", label: "\u82F1\u8BED" },
  { value: "ja", title: "Japanese", label: "\u65E5\u8BED" },
  { value: "ko", title: "Korean", label: "\u671D\u9C9C\u8BED" },
  { value: "fr", title: "French", label: "\u6CD5\u8BED" },
  { value: "ru", title: "Russian", label: "\u4FC4\u8BED" },
  { value: "ca", title: "Cantonese", label: "\u7CA4\u8BED" }
];
var gradeObj = {
  G: "\u666E\u904D\u7EA7",
  PG: "\u8F85\u5BFC\u7EA7",
  PG13: "\u5BB6\u957F\u6307\u5BFC\u7EA7",
  R: "\u9650\u5236\u7EA7",
  NC17: "\u6210\u4EBA\u7EA7"
};
var area = [
  { value: "CN", title: "CN", label: "\u4E2D\u56FD", flag: "https://www.themoviedb.org/images/flags_v2/64/CN.png", enname: "cn", grade: "G" },
  { value: "JP", title: "JP", label: "\u65E5\u672C", flag: "https://www.themoviedb.org/images/flags_v2/64/JP.png", enname: "jp", grade: "G" },
  { value: "HK", title: "HK", label: "\u4E2D\u56FD\u9999\u6E2F", flag: "https://www.themoviedb.org/images/flags_v2/64/HK.png", enname: "hk", grade: "G" },
  { value: "TW", title: "TW", label: "\u4E2D\u56FD\u53F0\u6E7E", flag: "https://www.themoviedb.org/images/flags_v2/64/TW.png", enname: "tw", grade: "G" },
  { value: "US", title: "US", label: "\u7F8E\u56FD", flag: "https://www.themoviedb.org/images/flags_v2/64/US.png", enname: "us", grade: "G" },
  { value: "KR", title: "KR", label: "\u97E9\u56FD", flag: "https://www.themoviedb.org/images/flags_v2/64/KR.png", enname: "kr", grade: "PG13,R,NC17" },
  { value: "GB", title: "GB", label: "\u82F1\u56FD", flag: "https://www.themoviedb.org/images/flags_v2/64/GB.png", enname: "gb", grade: "PG13" },
  { value: "FR", title: "FR", label: "\u6CD5\u56FD", flag: "https://www.themoviedb.org/images/flags_v2/64/FR.png", enname: "fr", grade: "PG13" },
  { value: "DE", title: "DE", label: "\u5FB7\u56FD", flag: "https://www.themoviedb.org/images/flags_v2/64/DE.png", enname: "de", grade: "PG13" },
  { value: "RU", title: "RU", label: "\u4FC4\u7F57\u65AF", flag: "https://www.themoviedb.org/images/flags_v2/64/RU.png", enname: "ru", grade: "PG13,R,NC17" },
  { value: "IN", title: "IN", label: "\u5370\u5EA6", flag: "https://www.themoviedb.org/images/flags_v2/64/IN.png", enname: "in", grade: "PG13,R,NC17" },
  { value: "MY", title: "MY", label: "\u9A6C\u6765\u897F\u4E9A", flag: "https://www.themoviedb.org/images/flags_v2/64/MY.png", enname: "my", grade: "PG13,R,NC17" }
];
var episodeStatusValue = {
  unfinished: "unfinished",
  completed: "completed",
  unreleased: "unreleased"
};
var episodeStatus = {
  [episodeStatusValue.unfinished]: "\u672A\u5B8C\u7ED3",
  [episodeStatusValue.completed]: "\u5DF2\u5B8C\u7ED3",
  [episodeStatusValue.unreleased]: "\u672A\u5F00\u64AD"
};
var personType = {
  constellation: "\u661F\u5EA7",
  blood_type: "\u8840\u578B",
  birth_place: "\u51FA\u751F\u5730",
  height: "\u8EAB\u9AD8",
  weight: "\u4F53\u91CD",
  nation: "\u6C11\u65CF",
  citizenship: "\u56FD\u7C4D",
  school: "\u6BD5\u4E1A\u5B66\u6821",
  company: "\u516C\u53F8",
  imdb: "imdb\u7F16\u53F7",
  website: "\u5B98\u65B9\u7F51\u7AD9",
  url: "\u5F15\u7528\u94FE\u63A5"
};
var anime = [
  "\u539F\u4F5C|\u539F\u4F5C|Original Creator/Original Work",
  "\u603B\u5BFC\u6F14|\u7DCF\u76E3\u7763|Chief Director",
  "\u5BFC\u6F14|\u76E3\u7763 \u30B7\u30EA\u30FC\u30BA\u76E3\u7763|Director/Direction",
  "\u811A\u672C|\u30B7\u30CA\u30EA\u30AA|Script/Screenplay",
  "\u5206\u955C|\u30B3\u30F3\u30C6  \u30B9\u30C8\u30FC\u30EA\u30FC\u30DC\u30FC\u30C9  \u753B\u30B3\u30F3\u30C6  \u7D75\u30B3\u30F3\u30C6|Storyboard",
  "\u6F14\u51FA|\u6F14\u51FA|Episode Direction",
  "\u97F3\u4E50|\u697D\u66F2  \u97F3\u697D|Music",
  "\u4EBA\u7269\u539F\u6848|\u30AD\u30E3\u30E9\u539F\u6848|Original Character Design",
  "\u4EBA\u7269\u8BBE\u5B9A|\u30AD\u30E3\u30E9\u8A2D\u5B9A|Character Design",
  "\u5206\u955C\u6784\u56FE|\u30EC\u30A4\u30A2\u30A6\u30C8|Layout",
  "\u7CFB\u5217\u6784\u6210|\u30B7\u30CA\u30EA\u30AA\u30C7\u30A3\u30EC\u30AF\u30BF\u30FC  \u69CB\u6210  \u30B7\u30EA\u30FC\u30BA\u69CB\u6210  \u811A\u672C\u69CB\u6210|Series Composition",
  "\u526F\u5BFC\u6F14|\u52A9\u76E3\u7763|Assistant Director",
  "\u7F8E\u672F\u76D1\u7763|\u30A2\u30FC\u30C8\u30C7\u30A3\u30EC\u30AF\u30B7\u30E7\u30F3 \u80CC\u666F\u76E3\u7763|Art Direction",
  "\u7F8E\u672F\u8BBE\u8BA1|\u7F8E\u8853\u8A2D\u5B9A|Art Design",
  "\u8272\u5F69\u8BBE\u8BA1|\u8272\u5F69\u8A2D\u5B9A|Color Design",
  "\u603B\u4F5C\u753B\u76D1\u7763|\u30C1\u30FC\u30D5\u4F5C\u753B\u76E3\u7763|Chief Animation Director",
  "\u4F5C\u753B\u76D1\u7763|\u4F5C\u76E3 \u30A2\u30CB\u30E1\u30FC\u30B7\u30E7\u30F3\u6F14\u51FA|Animation Direction",
  "\u673A\u68B0\u4F5C\u753B\u76D1\u7763|\u30E1\u30AB\u30CB\u30C3\u30AF\u4F5C\u76E3|Mechanical Animation Direction",
  "\u52A8\u4F5C\u4F5C\u753B\u76D1\u7763|\u30A2\u30AF\u30B7\u30E7\u30F3\u4F5C\u753B\u76E3\u7763|Action Animation Direction",
  "\u673A\u68B0\u8BBE\u5B9A|\u30E1\u30AB\u30CB\u30C3\u30AF\u8A2D\u5B9A|Mechanical Design",
  "\u6444\u5F71\u76D1\u7763|\u64AE\u5F71\u76E3\u7763|Director of Photography",
  "CG \u5BFC\u6F14|CG \u76E3\u7763|CG Director",
  "\u76D1\u4FEE|\u30B7\u30EA\u30FC\u30BA\u76E3\u4FEE \u30B9\u30FC\u30D1\u30FC\u30D0\u30A4\u30B6\u30FC|Supervision/Supervisor",
  "\u9053\u5177\u8BBE\u8BA1|\u30D7\u30ED\u30C3\u30D7\u30C7\u30B6\u30A4\u30F3|Prop Design",
  "\u539F\u753B|\u4F5C\u753B \u539F\u753B|Key Animation",
  "\u7B2C\u4E8C\u539F\u753B|\u539F\u753B\u5354\u529B|2nd Key Animation",
  "\u52A8\u753B\u68C0\u67E5|\u52D5\u753B\u30C1\u30A7\u30C3\u30AF|Animation Check",
  "\u5236\u4F5C|\u88FD\u4F5C \u88FD\u4F5C\u30B9\u30BF\u30B8\u30AA|Production",
  "\u52A8\u753B\u5236\u4F5C|\u30A2\u30CB\u30E1\u30FC\u30B7\u30E7\u30F3\u5236\u4F5C \u30A2\u30CB\u30E1\u5236\u4F5C \u30A2\u30CB\u30E1\u30FC\u30B7\u30E7\u30F3|Animation Work",
  "OP\u30FBED \u5206\u955C|OP\u30FBED \u5206\u93E1|OP ED",
  "OP\u30FBED \u6F14\u51FA|OP\u30FBED \u6F14\u51FA|OP\u30FBED Direction",
  "\u97F3\u4E50\u5236\u4F5C|\u697D\u66F2\u5236\u4F5C \u97F3\u697D\u5236\u4F5C|Music Work",
  "\u52A9\u7406\u5236\u7247\u4EBA|\u5354\u529B\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC|Assistant Producer",
  "\u52A9\u7406\u5236\u7247\u4EBA|\u30A2\u30BD\u30B7\u30A8\u30A4\u30C8\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC|Associate Producer",
  "\u80CC\u666F\u7F8E\u672F|\u80CC\u666F|Background Art",
  "\u8272\u5F69\u6307\u5B9A|\u8272\u5F69\u8A2D\u5B9A|Color Setting",
  "\u6570\u7801\u7ED8\u56FE|\u30C7\u30B8\u30BF\u30EB\u30DA\u30A4\u30F3\u30C8|Digital Paint",
  "3DCG|3DCG|3DCG",
  "\u5236\u4F5C\u7BA1\u7406|\u5236\u4F5C\u30DE\u30CD\u30FC\u30B8\u30E3\u30FC \u5236\u4F5C\u62C5\u5F53 \u5236\u4F5C\u73ED\u9577|Production Manager",
  "\u526A\u8F91|\u7DE8\u96C6|Editing",
  "\u539F\u6848|\u539F\u6848|Original Plan",
  "\u4E3B\u9898\u6B4C\u7F16\u66F2|\u30C6\u30FC\u30DE\u30BD\u30F3\u30B0\u30A2\u30EC\u30F3\u30B8\u30E1\u30F3\u30C8|Theme Song Arrangement",
  "\u4E3B\u9898\u6B4C\u4F5C\u66F2|\u30C6\u30FC\u30DE\u30BD\u30F3\u30B0\u4F5C\u66F2|Theme Song Composition",
  "\u4E3B\u9898\u6B4C\u4F5C\u8BCD|\u30C6\u30FC\u30DE\u30BD\u30F3\u30B0\u8A5E|Theme Song Lyrics",
  "\u4E3B\u9898\u6B4C\u6F14\u51FA|\u30C6\u30FC\u30DE\u30BD\u30F3\u30B0\u6F14\u594F|Theme Song Performance",
  "\u63D2\u5165\u6B4C\u6F14\u51FA|\u633F\u5165\u30BD\u30F3\u30B0\u6F14\u594F|Inserted Song Performance",
  "\u4F01\u753B|\u30D7\u30E9\u30F3\u30CB\u30F3\u30B0  \u4F01\u753B\u958B\u767A|Planning",
  "\u4F01\u5212\u5236\u4F5C\u4EBA|\u4F01\u753B\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC  \u4F01\u753B\u55B6\u696D\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC|Planning Producer",
  "\u5BA3\u4F20|\u30D1\u30D6\u30EA\u30B7\u30C6\u30A3  \u5BA3\u4F1D  \u5E83\u544A\u5BA3\u4F1D  \u756A\u7D44\u5BA3\u4F1D  \u88FD\u4F5C\u5BA3\u4F1D|Publicity",
  "\u5F55\u97F3|\u9332\u97F3|Recording",
  "\u5F55\u97F3\u52A9\u7406|\u9332\u97F3\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8  \u9332\u97F3\u52A9\u624B|Recording Assistant",
  "\u7CFB\u5217\u76D1\u7763|\u30B7\u30EA\u30FC\u30BA\u76E3\u7763|Series Production Director",
  "\u88FD\u4F5C|\u88FD\u4F5C|Production",
  "\u8BBE\u5B9A|\u8A2D\u5B9A|Setting",
  "\u97F3\u54CD\u76D1\u7763|\u97F3\u97FF\u76E3\u7763|Sound Director",
  "\u97F3\u54CD|\u97F3\u97FF|Sound",
  "\u97F3\u6548|\u97F3\u97FF\u52B9\u679C|Sound Effects",
  "\u7279\u6548|\u8996\u899A\u52B9\u679C|Special Effects",
  "\u914D\u97F3\u76D1\u7763|\u97F3\u58F0\u76E3\u7763|ADR Director",
  "\u8054\u5408\u5BFC\u6F14|\u5171\u540C\u76E3\u7763|Co-Director",
  "\u80CC\u666F\u8BBE\u5B9A|\u57FA\u672C\u8A2D\u5B9A  \u5834\u9762\u8A2D\u5B9A  \u5834\u9762\u8A2D\u8A08  \u8A2D\u5B9A|Setting",
  "\u8865\u95F4\u52A8\u753B|\u52D5\u753B|In-Between Animation",
  "\u6267\u884C\u5236\u7247\u4EBA|\u88FD\u4F5C\u7DCF\u6307\u63EE|Executive Producer",
  "\u52A9\u7406\u5236\u7247\u4EBA|\u5354\u529B\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC|Assistant Producer",
  "\u5236\u7247\u4EBA|\u30D7\u30ED\u30C7\u30E5\u30FC\u30B9  \u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC|Producer",
  "\u52A9\u7406\u5F55\u97F3\u5E08|\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u30A8\u30F3\u30B8\u30CB\u30A2|Assistant Engineer",
  "\u52A9\u7406\u5236\u7247\u534F\u8C03|\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8\u30D7\u30ED\u30C0\u30AF\u30B7\u30E7\u30F3\u30B3\u30FC\u30C7\u30A3\u30CD\u30FC\u30BF\u30FC|Assistant Production Coordinat",
  "\u6F14\u5458\u76D1\u7763|\u30AD\u30E3\u30B9\u30C6\u30A3\u30F3\u30B0\u30C7\u30A3\u30EC\u30AF\u30BF\u30FC|Casting Director",
  "\u603B\u5236\u7247|\u30C1\u30FC\u30D5\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC  \u30C1\u30FC\u30D5\u5236\u4F5C  \u7DCF\u5408\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC|Chief Producer",
  "\u8054\u5408\u5236\u7247\u4EBA|\u5171\u540C\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC|Co-Producer",
  "\u53F0\u8BCD\u7F16\u8F91|\u53F0\u8A5E\u7DE8\u96C6|Dialogue Editing",
  "\u540E\u671F\u5236\u7247\u534F\u8C03|\u30DD\u30B9\u30C8\u30D7\u30ED\u30C0\u30AF\u30B7\u30E7\u30F3\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8|Post-Production Assistant",
  "\u5236\u4F5C\u52A9\u624B|\u5236\u4F5C\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8 \u5236\u4F5C\u88DC\u4F50 \u88FD\u4F5C\u88DC|Production Assistant",
  "\u5236\u4F5C\u534F\u8C03|\u5236\u4F5C\u30B3\u30FC\u30C7\u30A3\u30CD\u30FC\u30BF\u30FC|Production Coordination",
  "\u5236\u4F5C\u534F\u529B|\u5236\u4F5C\u5354\u529B / \u4F5C\u54C1\u5354\u529B|Work Assistance",
  "\u53CB\u60C5\u5354\u529B|\u7279\u5225\u8B1D\u793C|Special Thanks",
  "\u4F5C\u753B\u76D1\u7763\u52A9\u7406|\u4F5C\u753B\u76E3\u7763\u88DC\u4F50|Assistant Animation Direction",
  "\u6F14\u51FA\u52A9\u7406|\u6F14\u51FA\u88DC\u4F50|Assistant Episode Direction",
  "\u8272\u5F69\u811A\u672C|\u8272\u5F69\u811A\u672C|Color Script",
  "\u4E3B\u52A8\u753B\u5E08|\u4E3B\u52A8\u4F5C\u753B|Main Animator",
  "\u526F\u4EBA\u7269\u8BBE\u5B9A|\u526F\u4EBA\u7269\u8A2D\u5B9A|Sub-Character Design",
  "\u5236\u4F5C\u8FDB\u884C|\u88FD\u4F5C\u9032\u884C|Assistant Production Manager",
  "\u5236\u4F5C\u8FDB\u884C\u534F\u529B|\u88FD\u4F5C\u9032\u884C\u5354\u529B|Assistant Production Manager Assistance",
  "\u670D\u88C5\u8BBE\u8BA1|\u8863\u88C5\u8A2D\u8A08|Costume Design",
  "\u534F\u529B|\u5354\u529B|Assistance",
  "\u6444\u5F71|\u64AE\u5F71|Photography",
  "\u8BBE\u5B9A\u5236\u4F5C|\u8A2D\u5B9A\u88FD\u4F5C|Design Manager",
  "3DCG \u5BFC\u6F14|3DCG \u76E3\u7763|3DCG Director",
  "\u52A8\u753B\u5236\u7247\u4EBA|\u30A2\u30CB\u30E1\u30FC\u30B7\u30E7\u30F3\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC|Animation Producer",
  "\u97F3\u4E50\u5236\u4F5C\u4EBA|\u97F3\u697D\u88FD\u4F5C|Music Producer",
  "\u4E0A\u8272|\u30DA\u30A4\u30F3\u30C8|Painting",
  "\u4E0A\u8272\u68C0\u67E5|\u30DA\u30A4\u30F3\u30C8\u30C1\u30A7\u30C3\u30AF|Painting Check",
  "\u4F01\u753B\u534F\u529B|\u4F01\u753B\u5354\u529B|Planning Cooperation",
  "\u89C6\u89C9\u6982\u5FF5|\u89C6\u89C9\u6982\u5FF5|Visual Concept",
  "2D\u8BBE\u8BA1|2D \u8BBE\u8BA1|2D WORKS",
  "\u7279\u6548\u4F5C\u753B\u76D1\u7763|\u7279\u6548\u4F5C\u753B\u76E3\u7763|Special Effects Animation Direction",
  "\u97F3\u7BB1\u5236\u4F5C\u62C5\u5F53|\u30B5\u30A6\u30F3\u30C9\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC|Sound Production Coordinator",
  "\u602A\u7269\u8BBE\u8BA1|\u30E2\u30F3\u30B9\u30BF\u30FC\u30C7\u30B6\u30A4\u30F3|Monster Design",
  "\u5236\u4F5C\u7EDF\u62EC|\u88FD\u4F5C\u7D71\u62EC|Chief Production Supervisor",
  "\u63D2\u5165\u6B4C\u4F5C\u8BCD|\u63D2\u5165\u6B4C\u4F5C\u8BCD|Inserted Song Lyrics",
  "\u63D2\u5165\u6B4C\u4F5C\u66F2|\u63D2\u5165\u6B4C\u4F5C\u66F2|Inserted Song Composition",
  "\u63D2\u5165\u6B4C\u7F16\u66F2|\u633F\u5165\u30BD\u30F3\u30B0\u7DE8\u66F2|Inserted Song Arrangement",
  "\u5F55\u97F3\u5DE5\u4F5C\u5BA4|\u9332\u97F3\u30EF\u30FC\u30AF\u30B9\u30DA\u30FC\u30B9|Recording Studio",
  "\u8BBE\u5B9A\u534F\u529B|\u8A2D\u5B9A\u5354\u529B|Setting Cooperation",
  "\u6574\u97F3|\u6574\u97F3|Sound Mixing",
  "\u811A\u672C\u534F\u529B|\u811A\u672C\u5354\u529B|Script Cooperation",
  "\u6444\u5F71\u76D1\u7763\u52A9\u7406|\u651D\u5F71\u76E3\u7763\u88DC\u4F50|Assistant Director of Photography",
  "\u5236\u4F5C\u7BA1\u7406\u52A9\u7406|\u88FD\u4F5C\u7BA1\u7406\u88DC\u4F50|Assistant Production Desk",
  "\u76D1\u5236|\u30B9\u30FC\u30D1\u30FC\u30D0\u30A4\u30B8\u30F3\u30B0\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC|Supervising Producer",
  "\u521B\u610F\u603B\u76D1|\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6\u30C7\u30A3\u30EC\u30AF\u30BF\u30FC|Creative Supervisor/Director",
  "\u97F3\u4E50\u76D1\u7763|\u97F3\u697D\u76E3\u7763|Music Director",
  "\u6982\u5FF5\u827A\u672F|\u6982\u5FF5\u30A2\u30FC\u30C8|Concept Art",
  "Live \u5206\u955C\u6F14\u51FA|Live \u5206\u955C\u6F14\u51FA|Live Storyboard Direction",
  "\u63D2\u753B|\u30A4\u30E9\u30B9\u30C8|Illustration",
  "\u89C6\u89C9\u6548\u679C|\u8996\u899A\u52B9\u679C|Visual Effects",
  "\u5BA3\u4F20\u5236\u7247\u4EBA|\u30D1\u30D6\u30EA\u30B7\u30C6\u30A3\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC|Publicity Producer",
  "\u89C6\u89C9\u5BFC\u6F14|\u8996\u899A\u30C7\u30A3\u30EC\u30AF\u30BF\u30FC|Visual Director",
  "\u6784\u6210\u534F\u529B|\u69CB\u6210\u5354\u529B|Series Composition Cooperation",
  "\u7F8E\u672F\u76D1\u7763\u52A9\u7406|\u7F8E\u8853\u76E3\u7763\u88DC\u4F50|Assistant Art Director",
  "\u4E3B\u6F14\u51FA|\u4E3B\u6F14\u51FA|Chief Episode Direction"
];
var real = [
  "\u539F\u4F5C|\u539F\u4F5C|creator",
  "\u5BFC\u6F14|\u76E3\u7763|director",
  "\u521B\u610F\u603B\u76D1|\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6\u30C7\u30A3\u30EC\u30AF\u30BF\u30FC|creative director",
  "\u7F16\u5267|\u811A\u672C|writer",
  "\u97F3\u4E50|\u97F3\u697D|composer",
  "\u6267\u884C\u5236\u7247\u4EBA|\u88FD\u4F5C\u7DCF\u6307\u63EE|executive producer",
  "\u5171\u540C\u6267\u884C\u5236\u4F5C|\u5171\u540C\u5B9F\u884C\u5236\u4F5C|co exec producer",
  "\u5236\u7247\u4EBA|\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC|producer",
  "\u76D1\u5236|\u30B9\u30FC\u30D1\u30FC\u30D0\u30A4\u30B8\u30F3\u30B0\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC|supervising producer",
  "\u526F\u5236\u4F5C\u4EBA|\u526F\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC|consulting producer",
  "\u6545\u4E8B|\u30B9\u30C8\u30FC\u30EA\u30FC|story",
  "\u7F16\u5BA1|\u811A\u672C\u7DE8\u96C6|story editor",
  "\u526A\u8F91|\u7DE8\u96C6|editor",
  "\u6444\u5F71|\u64AE\u5F71|cinematography",
  "\u4E3B\u9898\u6B4C\u6F14\u51FA|\u4E3B\u984C\u6B4C\u6F14\u594F|Theme Song Performance",
  "\u4E3B\u6F14|\u4E3B\u6F14|Actor",
  "\u914D\u89D2|\u8107\u5F79|Supporting Actor",
  "\u5236\u4F5C|\u88FD\u4F5C|Production"
];
var music = [
  "\u827A\u672F\u5BB6|\u30A2\u30FC\u30C6\u30A3\u30B9\u30C8|Artist",
  "\u5236\u4F5C\u4EBA|\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC|Producer",
  "\u4F5C\u66F2|\u4F5C\u66F2|Composer",
  "\u4F5C\u8BCD|\u4F5C\u8A5E|Lyric",
  "\u7F16\u66F2|\u7DE8\u66F2|Arrange",
  "\u63D2\u56FE|\u30A4\u30E9\u30B9\u30C8|Illustrator",
  "\u5F55\u97F3|\u9332\u97F3|Recording",
  "\u5382\u724C|\u30EC\u30FC\u30D9\u30EB|Label",
  "\u539F\u4F5C|\u539F\u4F5C|Original Creator/Original Work",
  "\u811A\u672C|\u30B7\u30CA\u30EA\u30AA|Scenario"
];
var book = [
  "\u539F\u4F5C|\u539F\u4F5C|Original Creator/Original Work",
  "\u4F5C\u8005|\u4F5C\u8005|Author",
  "\u4F5C\u753B|\u4F5C\u753B|Key Animation",
  "\u63D2\u56FE|\u30A4\u30E9\u30B9\u30C8|Illustration",
  "\u51FA\u7248\u793E|\u51FA\u7248\u793E|Publisher",
  "\u8FDE\u8F7D\u6742\u5FD7|\u63B2\u8F09\u8A8C|Serialized Magazine",
  "\u8BD1\u8005|\u7FFB\u8A33\u8005|Translator",
  "\u5BA2\u4E32|\u30B2\u30B9\u30C8|Guest",
  "\u4EBA\u7269\u539F\u6848|\u30AD\u30E3\u30E9\u30AF\u30BF\u30FC\u539F\u6848|Original Character Design"
];
var game = [
  "\u5F00\u53D1|\u958B\u767A\u5143|developer",
  "\u53D1\u884C|\u767A\u58F2\u5143|publisher",
  "\u904A\u6232\u8A2D\u8A08\u5E2B|\u30B2\u30FC\u30E0\u30AF\u30EA\u30A8\u30A4\u30BF\u30FC|game designer",
  "\u539F\u4F5C|\u539F\u4F5C|Original Creator",
  "\u5BFC\u6F14|\u76E3\u7763 \u6F14\u51FA \u30B7\u30EA\u30FC\u30BA\u76E3\u7763|Director/Direction",
  "\u5236\u4F5C\u4EBA|\u30D7\u30ED\u30C7\u30E5\u30FC\u30B5\u30FC|Producer",
  "\u4F01\u753B|\u4F01\u753B|Planning",
  "\u76D1\u4FEE|\u76E3\u4FEE|Supervision",
  "\u5267\u672C|\u8173\u672C|Script",
  "\u7CFB\u5217\u6784\u6210|\u30B7\u30EA\u30FC\u30BA\u69CB\u6210|Series Composition",
  "\u4F5C\u753B\u76D1\u7763|\u4F5C\u753B\u76E3\u7763|Animation Direction",
  "\u539F\u753B|\u539F\u753B|Key Animation",
  "\u4EBA\u7269\u8BBE\u5B9A|\u30AD\u30E3\u30E9\u8A2D\u5B9A \u30AD\u30E3\u30E9\u30AF\u30BF\u30FC\u30C7\u30B6\u30A4\u30F3|Character Design",
  "\u673A\u68B0\u8BBE\u5B9A|\u30E1\u30AB\u30CB\u30C3\u30AF\u8A2D\u5B9A|Mechanical Design",
  "\u7F8E\u5DE5|\u7F8E\u8853|Art Design",
  "CG\u76D1\u4FEE|CG\u76E3\u4FEE|CG Supervision",
  "SD\u539F\u753B|SD\u539F\u753B|SD Key Animation",
  "\u80CC\u666F|\u80CC\u666F|Background Art",
  "\u97F3\u54CD\u76D1\u7763|\u97F3\u97FF\u76E3\u7763|Sound Director",
  "\u97F3\u4E50|\u97F3\u697D|Music",
  "\u7A0B\u5E8F|\u30D7\u30ED\u30B0\u30E9\u30E0|Program",
  "\u52A8\u753B\u5236\u4F5C|\u30A2\u30CB\u30E1\u30FC\u30B7\u30E7\u30F3\u5236\u4F5C \u30A2\u30CB\u30E1\u5236\u4F5C \u30A2\u30CB\u30E1\u30FC\u30B7\u30E7\u30F3|Animation Work",
  "\u52A8\u753B\u76D1\u7763|\u30A2\u30CB\u30E1\u30FC\u30B7\u30E7\u30F3\u76E3\u7763|Animation Director",
  "\u52A8\u753B\u5267\u672C|\u30A2\u30CB\u30E1\u30FC\u30B7\u30E7\u30F3\u811A\u672C|Animation Script",
  "\u5236\u4F5C\u603B\u6307\u6325|\u5236\u4F5C\u7DCF\u6307\u63EE|Chief Production Supervisor",
  "QC|QC|QC",
  "\u5173\u5361\u8BBE\u8BA1|\u30EC\u30D9\u30EB\u30C7\u30B6\u30A4\u30F3|Level Design",
  "\u4E3B\u9898\u6B4C\u4F5C\u66F2|\u4E3B\u984C\u6B4C\u4F5C\u66F2|Theme Song Composition",
  "\u4E3B\u9898\u6B4C\u4F5C\u8BCD|\u4E3B\u984C\u6B4C\u4F5C\u8A5E|Theme Song Lyrics",
  "\u4E3B\u9898\u6B4C\u6F14\u51FA|\u4E3B\u984C\u6B4C\u6F14\u594F|Theme Song Performance",
  "\u63D2\u5165\u6B4C\u6F14\u51FA|\u633F\u5165\u6B4C\u6F14\u594F|Inserted Song Performance",
  "\u534F\u529B|\u5354\u529B|Cooperation"
];
var career = [
  { value: "seiyu", label: "\u58F0\u4F18" },
  { value: "actor", label: "\u6F14\u5458" },
  { value: "artist", label: "\u97F3\u4E50\u4EBA" },
  { value: "mangaka", label: "\u6F2B\u753B\u5BB6" },
  { value: "producer", label: "\u5236\u4F5C\u4EBA\u5458" }
];
var careerType = career.reduce((prev, cur) => {
  prev[cur.value] = cur.label;
  return prev;
}, {});
var relationType = {
  1: "\u6539\u7F16 / Adaptation",
  2: "\u524D\u4F20 / Prequel",
  3: "\u7EED\u96C6 / Sequel",
  4: "\u603B\u96C6\u7BC7 / Summary",
  5: "\u5168\u96C6 / Full Story",
  6: "\u756A\u5916\u7BC7 / Side Story",
  7: "\u89D2\u8272\u51FA\u6F14 / Character",
  8: "\u76F8\u540C\u4E16\u754C\u89C2 / Same Setting",
  9: "\u4E0D\u540C\u4E16\u754C\u89C2 / Alternative Setting",
  10: "\u4E0D\u540C\u6F14\u7ECE / Alternative Version",
  11: "\u884D\u751F / Spin-off",
  12: "\u4E3B\u7EBF\u6545\u4E8B / Parent Story",
  14: "\u8054\u52A8 / Collaboration",
  99: "\u5176\u4ED6 / Other"
};
function strToArr(arr) {
  return arr.map((item, i) => {
    const d = item.split("|");
    return {
      id: i + 1,
      name: d[0]?.trim() || "",
      jp_name: d[1]?.trim() || "",
      en_name: d[2]?.trim() || ""
    };
  });
}
function strToObj(arr) {
  return arr.reduce((prev, cur, i) => {
    const data = cur.split("|");
    prev[data[2]] = {
      id: i + 1,
      name: data[0]?.trim() || "",
      jp_name: data[1]?.trim() || "",
      en_name: data[2]?.trim() || ""
    };
    return prev;
  }, {});
}
var animeStaffArr = strToArr(anime);
var animeStaffObj = strToObj(anime);
var animeStaffMap = Object.values(animeStaffObj).reduce(
  (prev, cur) => {
    prev[cur.en_name] = cur.name;
    return prev;
  },
  {}
);
var personCharactersType = {
  1: "CV",
  2: "CV",
  3: "\u4E2D\u914D",
  4: "\u65E5\u914D",
  5: "\u97E9\u914D",
  6: "\u82F1\u914D"
};
var charactersType = {
  1: "\u4E3B\u89D2",
  2: "\u914D\u89D2",
  3: "\u5BA2\u4E32",
  4: "\u95F2\u89D2",
  5: "\u65C1\u767D",
  6: "\u58F0\u5E93"
};
var genderOptionsList = [
  { label: "\u672A\u77E5", value: 0 },
  { label: "\u5973", value: 1 },
  { label: "\u7537", value: 2 },
  { label: "\u5176\u4ED6", value: 3 }
];
var department = [
  { value: "Art", label: "\u827A\u672F" },
  { value: "Visual Effects", label: "\u89C6\u6548" },
  { value: "Directing", label: "\u5BFC\u6F14" },
  { value: "Writing", label: "\u7F16\u8F91" },
  { value: "Camera", label: "\u6444\u50CF" },
  { value: "Editing", label: "\u526A\u8F91" },
  { value: "Production", label: "\u5236\u7247" },
  { value: "Sound", label: "\u5F55\u97F3" },
  { value: "Costume & Make-Up", label: "\u670D\u88C5\u53CA\u5236\u4F5C" },
  { value: "Crew", label: "\u673A\u7EC4\u4EBA\u5458" },
  { value: "Lighting", label: "\u706F\u5149" },
  { value: "Acting", label: "\u6F14\u5458" }
];
var job = [
  { value: "voice", label: "\u914D\u97F3" },
  { value: "Visual Effects", label: "\u89C6\u6548" },
  { value: "Directing", label: "\u5BFC\u6F14" },
  { value: "Writing", label: "\u7F16\u8F91" },
  { value: "Camera", label: "\u6444\u50CF" },
  { value: "Editing", label: "\u526A\u8F91" },
  { value: "Production", label: "\u5236\u7247" },
  { value: "Sound", label: "\u5F55\u97F3" },
  { value: "Costume & Make-Up", label: "\u670D\u88C5\u53CA\u5236\u4F5C" },
  { value: "Crew", label: "\u673A\u7EC4\u4EBA\u5458" },
  { value: "Lighting", label: "\u706F\u5149" },
  { value: "Acting", label: "\u6F14\u5458" }
];

// index.ts
function getSeason() {
  const currentMonth = (/* @__PURE__ */ new Date()).getMonth() + 1;
  const seasonMap = {
    1: "winter",
    2: "winter",
    3: "winter",
    4: "spring",
    5: "spring",
    6: "spring",
    7: "summer",
    8: "summer",
    9: "summer",
    10: "fall",
    11: "fall",
    12: "fall"
  };
  const currentSeason = seasonMap[currentMonth];
  const currentYear = `${(/* @__PURE__ */ new Date()).getFullYear()}`;
  return { currentSeason, currentYear };
}
export {
  ActivityAction,
  ActivityActionName,
  anime,
  animeStaffArr,
  animeStaffMap,
  animeStaffObj,
  area,
  book,
  career,
  careerType,
  charactersType,
  defaultTags,
  department,
  episodeStatus,
  episodeStatusValue,
  feedType,
  game,
  genderOptionsList,
  genderType,
  getSeason,
  gradeObj,
  job,
  lang,
  langType,
  modelEnName,
  modelName,
  modelType,
  music,
  personCharactersType,
  personType,
  picType,
  rateType,
  real,
  relationType,
  season,
  seasonType,
  sidName,
  source,
  sourceSite,
  sourceType,
  statusType
};
